import { render, staticRenderFns } from "./DocumentTypesList.vue?vue&type=template&id=66309f4f&"
import script from "./DocumentTypesList.vue?vue&type=script&lang=js&"
export * from "./DocumentTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports